"use client";

import React from "react";
import useCountDown from "@/hooks/useCountDown";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";

function CampaignCountdown({ endDate }) {
  const t = useTranslationDetector();
  const { days, hours, minutes, seconds, isExpired } = useCountDown(endDate);

  if (isExpired) {
    return null;
  }

  const formatTime = (value) => String(value).padStart(2, "0");

  const timeUnits = [
    { value: days, label: t("campaigns.day") || "Gün" },
    { value: hours, label: t("campaigns.hour") || "Saat" },
    { value: minutes, label: t("campaigns.minute") || "Dakika" },
    { value: seconds, label: t("campaigns.second") || "Saniye" },
  ];

  return (
    <div className="flex flex-col gap-4">
      <span className="font-semibold text-xl/26 text-foreground">{t("campaigns.campaignCountdownTitle")}</span>
      <div className="rounded-lg border border-danger-subtle bg-danger-weaker px-[32px] py-[12px]">
        <div className="flex items-center justify-between gap-4">
          {timeUnits.map((unit, index) => (
            <React.Fragment key={unit.label}>
              <div className="flex flex-col items-center">
                <span className="text-[23px]/[30px] font-semibold text-danger-emphasis">
                  {formatTime(unit.value)}
                </span>
                <span className="text-[12px]/[16px] font-normal text-danger-emphasis">
                  {unit.label}
                </span>
              </div>
              {index < timeUnits.length - 1 && (
                <span className="text-[23px]/[30px] font-semibold text-danger-emphasis">
                  :
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CampaignCountdown;
